/* Fills the header's class badge when the cart has no Klasse attribute yet.

   snippets/klasse-badge.liquid renders the value straight from the cart where
   there is one, which covers the ordinary case with no flash. When the gate's
   cart request never landed the attribute is empty but the class is still in
   localStorage, which is the same gap assets/klasse-field.js closes on the cart
   page. This is the header's half of that.

   Storage keys are assets/school-gate.js's: skole:active holds the handle of
   the school unlocked last, skole:<handle>:klasse holds its class.

   A custom element rather than an inline script, matching klasse-field.js: the
   header re-renders on cart updates, and script tags injected that way never
   execute while custom elements upgrade on their own. */
(function () {
  "use strict";

  function read(key) {
    try {
      return window.localStorage.getItem(key);
    } catch (e) {
      return null;
    }
  }

  /* The class of the school being shopped. Prefers the one unlocked last, so a
     device that has seen two schools shows the right one, then falls back to any
     stored class for a visitor whose storage predates skole:active. */
  function storedKlasse() {
    var active = read("skole:active");
    if (active) {
      var value = read("skole:" + active + ":klasse");
      if (value) return value;
    }

    try {
      for (var i = 0; i < window.localStorage.length; i++) {
        var key = window.localStorage.key(i);
        if (key && /^skole:.+:klasse$/.test(key)) {
          var stored = window.localStorage.getItem(key);
          if (stored) return stored;
        }
      }
    } catch (e) {}

    return null;
  }

  class KlasseBadge extends HTMLElement {
    connectedCallback() {
      this.value = this.querySelector("[data-klasse-badge-value]");
      if (!this.value) return;

      var rendered = this.value.textContent.trim();
      var klasse = storedKlasse();

      /* The stored class wins over the rendered one, the same way it does in
         assets/klasse-field.js, and for the same reason: both are written by
         the gate together, so they only come apart when the gate's cart request
         did not land, and there the browser holds the newer answer. klasse-field
         then pushes it to the cart - after this markup was rendered.

         This used to stop at "rendered, therefore right", which meant the badge
         could sit in the header naming the class the student had just changed
         AWAY from while the cart below it named the new one. The badge exists to
         catch a wrong class on the first screen; a stale one does the opposite.

         With nothing stored - storage cleared, private mode - the rendered value
         is all there is, and it stays. */
      if (klasse && klasse !== rendered) this.value.textContent = klasse;

      if (this.value.textContent.trim()) this.removeAttribute("hidden");
    }
  }

  if (!customElements.get("klasse-badge")) {
    customElements.define("klasse-badge", KlasseBadge);
  }
})();
